<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7Cw0F1/tc-custom/9780830874149.jpg?1696642670028" alt="This image is the cover for the book Spiritual Warfare, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spiritual Warfare, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>What is spiritual warfare? How can I recognize it? In what ways does it affect me? The Bible has much to say about the temptations and struggles you face day by day. In this nine session LifeGuide® Bible Study will deepen your understanding of spiritual warfare and direct you to God-given sources of power, assurance and hope. For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Kuhatschek
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06fff96a